import React from "react";
import DashboardNav from "../components/DashboardNav";
import { Container, Row, Col, Card } from "react-bootstrap";
import HubspotContactForm from "../components/HubspotContactForm";

const SpycareHelpDesk = () => {
    return (
        <>
            <Container>
                <Row>
                    <Col xs={12} className="mt-2">
                        <h1>Help Desk</h1>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <HubspotContactForm portalId="5956590" formId="735e7fba-951e-4942-909b-de2dedd42d05"/>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default SpycareHelpDesk